import ajax from "../utils/request";
const activeApi = {
  /********************************活动列表*********************************** */
  // 活动列表
  getWebActivity(params) {
    return ajax({
      url: "/activity",
      type: "get",
      params: params,
    });
  },
  // 新增活动
  addWebActivity(params) {
    return ajax({
      url: "/activity",
      type: "post",
      params: params,
    });
  },

  //编辑活动
  editWebActive(params) {
    return ajax({
      url: "/activity",
      type: "put",
      params: params,
    });
  },

  /********************************新版活动列表*********************************** */
  // 活动列表
  getActivity(params) {
    return ajax({
      url: "/actv/list",
      type: "get",
      params: params,
    });
  },
  // 新增活动
  addActivity(params) {
    return ajax({
      url: "/actv/add",
      type: "post",
      params: params,
    });
  },

  //编辑活动
  editActive(params) {
    return ajax({
      url: "/actv/update",
      type: "post",
      params: params,
    });
  },

  /********************************一次活动列表*********************************** */
  // 活动列表
  getOneActivity(params) {
    return ajax({
      url: "/task/once/list",
      type: "get",
      params: params,
    });
  },
  // 新增活动
  addOneActivity(params) {
    return ajax({
      url: "/task/once/add",
      type: "post",
      params: params,
    });
  },

  //编辑活动
  editOneActive(params) {
    return ajax({
      url: "/task/once/edit",
      type: "post",
      params: params,
    });
  },
  /********************************每日活动列表*********************************** */
  // 活动列表
  getDailyActivity(params) {
    return ajax({
      url: "/task/daily/list",
      type: "get",
      params: params,
    });
  },
  // 新增活动
  addDailyActivity(params) {
    return ajax({
      url: "/task/daily/add",
      type: "post",
      params: params,
    });
  },

  //编辑活动
  editDailyActive(params) {
    return ajax({
      url: "/task/daily/edit",
      type: "post",
      params: params,
    });
  },

  /********************************活动奖品列表*********************************** */
  //获取奖品
  getWebPrice(params) {
    return ajax({
      url: "/activity/prize",
      type: "get",
      params: params,
    });
  },
  //新增奖品
  addWebPrice(params) {
    return ajax({
      url: "/activity/prize",
      type: "post",
      params: params,
    });
  },
  //修改奖品
  editWebPrice(params) {
    return ajax(
      {
        url: "/activity/prize",
        type: "put",
        params: params,
      },
      true
    );
  },
  //获取活动ID
  getActiveityId(params) {
    return ajax({
      url: "/activity/box",
      type: "get",
      params: params,
    });
  },
  //获取会员卡ID
  getVipcardId(params) {
    return ajax({
      url: "/activity/prize/vipBox",
      type: "get",
      params: params,
    });
  },

  /********************************奖池*********************************** */
  // 获取奖池
  getPrizePool(params) {
    return ajax({
      url: "/activity/prizePool",
      type: "get",
      params: params,
    });
  },
  // 新增奖池
  addPrizePool(params) {
    return ajax({
      url: "/activity/prizePool",
      type: "post",
      params: params,
    });
  },
  // 修改奖池
  editPrizePool(params) {
    return ajax({
      url: "/activity/prizePool",
      type: "put",
      params: params,
    });
  },

  /********************************奖池*********************************** */

  /********************************活动奖品列表*********************************** */
  /**
   * 奖品列表
   * @param {object} [params]            - 需要的参数
   * @param {string} [params.actID]      - 活动id
   * @param {number} [params.pageNumber] - 页码【从1开始计数】
   * @param {number} [params.pageSize]   - 每页显示的条数【从1开始计数】
   */
  getActivityPrize(params) {
    return ajax({
      url: "/activity/reward/list",
      type: "get",
      params: params,
    });
  },
  /**
   * 新增奖品
   * @param {object} [params]            - 需要的参数
   * @param {string} [params.actID]      - 活动id
   * @param {number} [params.pageNumber] - 页码【从1开始计数】
   * @param {number} [params.pageSize]   - 每页显示的条数【从1开始计数】
   */
  addActivityPrize(params) {
    return ajax({
      url: "/activity/reward/add",
      type: "post",
      params: params,
    });
  },
  /**
   * 编辑奖品
   * @param {object} [params]            - 需要的参数
   * @param {string} [params.actID]      - 活动id
   * @param {number} [params.pageNumber] - 页码【从1开始计数】
   * @param {number} [params.pageSize]   - 每页显示的条数【从1开始计数】
   */
  editActivityPrize(params) {
    return ajax({
      url: "/activity/reward/modify",
      type: "post",
      params: params,
    });
  },
  /********************************兑换码列表*********************************** */
  // 兑换码列表
  redemptionCodeList(params) {
    return ajax({
      url: "/exchange/code/list",
      type: "get",
      params: params,
    });
  },
  // 添加兑换码
  addCode(params) {
    return ajax({
      url: "/exchange/code/add",
      type: "post",
      params: params,
    });
  },
  // 修改兑换码
  editCode(params) {
    return ajax({
      url: "/exchange/code/update",
      type: "post",
      params: params,
    });
  },
  // 删除兑换码
  delCode(params) {
    return ajax({
      url: "/exchange/code/del",
      type: "delete",
      params: params,
    });
  },
  /********************************兑换码兑换日志*********************************** */
  redemptionLogList(params) {
    return ajax({
      url: "/exchange/log/list",
      type: "get",
      params: params,
    });
  },

  /********************************获奖记录列表（嫩模活动）*********************************** */

  //添加获奖记录列表
  addWinRecord(params) {
    return ajax({
      url: "/newactivity/addWinRecord",
      type: "post",
      params: params,
    });
  },

  //导入所有嫩模
  importModels(params) {
    return ajax({
      url: "/newactivity/importModels",
      type: "post",
      params: params,
    });
  },

  //写入参数活动人数
  updateJoinNum(params) {
    return ajax({
      url: "/newactivity/updateJoinNum",
      type: "post",
      params: params,
    });
  },
  //
  // 嫩模获奖记录
  winRecordPage(params) {
    return ajax({
      url: "/newactivity/winRecordPage",
      type: "post",
      params: params,
    });
  },

  /********************************购买列表*********************************** */

  //购买列表
  buyPage(params) {
    return ajax({
      url: "/newactivity/buyPage",
      type: "post",
      params: params,
    });
  },

  /******************************** 摇奖号列表*********************************** */

  //请求列表
  getLottery(params) {
    return ajax({
      url: "/lottnum/list",
      type: "get",
      params: params,
    });
  },

  /********************************兑换码类型*********************************** */
  // 兑换码类型列表
  // redemptionTypeList(params) {
  //   return ajax({
  //     url: '/exchange/type/list',
  //     type: 'get',
  //     params: params
  //   })
  // },
  // // 添加兑换码类型
  // addType(params) {
  //   return ajax({
  //     url: '/exchange/type/add',
  //     type: 'post',
  //     params: params
  //   })
  // },
  // // 删除兑换码类型
  // delType(params) {
  //   return ajax({
  //     url: '/exchange/type/del',
  //     type: 'delete',
  //     params: params
  //   })
  // },
  // // 修改兑换码类型
  // editType(params) {
  //   return ajax({
  //     url: '/exchange/type/update',
  //     type: 'post',
  //     params: params
  //   })
  // }
  /** ********************楼凤列表************************* */
  // 获取楼凤列表
  getLouFengList(params) {
    return ajax({
      url: "/loufeng/list",
      type: "post",
      params: params,
    });
  },
  // 新增
  addLoufeng(params) {
    return ajax({
      url: "/loufeng/add",
      type: "post",
      params: params,
    });
  },
  // 修改
  updateLoufeng(params) {
    return ajax({
      url: "/loufeng/edit",
      type: "post",
      params: params,
    });
  },
  // 删除
  deleteLoufeng(params) {
    return ajax({
      url: "/loufeng/del",
      type: "delete",
      params: params,
    });
  },

  /** **************砸蛋活动流水********************* */
  // 获取砸蛋活动流水
  getWinRecord(params) {
    return ajax({
      url: "/activity/record",
      type: "get",
      params: params,
    });
  },
  // 获取奖品名字列表
  getPrizeNames(params) {
    return ajax({
      url: "/sge/winRecord/prizeNames",
      type: "get",
      params: params,
    });
  },
};

export default activeApi;
